import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import {dataSourceHandleActions, organizationActions, portalActions} from "_actions";
import {Typography} from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {Loading} from "../common";
import {
  AddPortalModal,
  EditPortalModal,
  DeletePortalModal,
  OrganizationPortal,
  ViewPortalModal
} from "components/Portal";
import {isObjectEmpty, groupDataBy} from "_helpers";
import {publicAndFeaturedVisibility} from "../../_constants";
import styles from "./Styles.module.css";

/**
 * @author: Chris Okebata
 */

class Portal extends Component {

  constructor(props){
    super(props);

    this.state = {
      expanded: false,
      expandedOrg: '',
      addPortalModalStatus: false,
      editPortalModalStatus: false,
      deletePortalModalStatus: false,
      viewPortalModalStatus: false,
      selectedPortal: {},
    }
  }

  componentDidMount() {
    const {dispatch} = this.props;

    dispatch(organizationActions.getAll({visibility: publicAndFeaturedVisibility}));
    dispatch(portalActions.getAll());
    dispatch(portalActions.getAllIntegratedPortals());
    dispatch(dataSourceHandleActions.getAll({ handleStatus: 'LIVE' }));
  }

  resetSelection = () => {
    this.setState({
      selectedPortal: {},
    })
  };

  closePortalModal = (name) => {
    this.setState({
      [name]: false,
    });

    this.resetSelection();
  };

  openPortalModal = (event, name, data) => {
    event.stopPropagation();

    this.setState({
      [name]: true,
      selectedPortal: data,
    });
  };

  renderOrganizationRow = (item, classes) => {

    const orgName = item[0];

    return(
      <div className={styles.root} key={orgName}>
        <Accordion className={styles.expansionPanel}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-label="Expand"
            aria-controls="additional-actions1-content"
            id="additional-actions1-header"
            className={styles.expansionPanelSummary}
          >
            <Typography className={styles.typography15}>
              {orgName || ''}
            </Typography>
          </AccordionSummary>
          <OrganizationPortal portalArr={item[1]} openModal={this.openPortalModal}/>
        </Accordion>
      </div>
    )
  };

  render() {

    const { allPortals, classes } = this.props;

    if (isObjectEmpty(allPortals)) {
      return <Loading />
    }

    const groupedData = groupDataBy(allPortals.portal, 'organization', 'name');

    return(
      <Fragment>
        <AddPortalModal
          headerText="Add portal"
          buttonText="Add portal"
          onHide={() => {this.closePortalModal('addPortalModalStatus')}}
          show={this.state.addPortalModalStatus}
        />

        <EditPortalModal
          headerText="Edit portal"
          buttonText="Edit portal"
          onHide={() => {this.closePortalModal('editPortalModalStatus')}}
          show={this.state.editPortalModalStatus}
          portalData={this.state.selectedPortal}
        />

        <DeletePortalModal
          headerText="Delete portal"
          buttonText="Delete portal"
          onHide={() => {this.closePortalModal('deletePortalModalStatus')}}
          show={this.state.deletePortalModalStatus}
          portalData={this.state.selectedPortal}
        />

        <ViewPortalModal
          headerText="View portal"
          buttonText="OK"
          onHide={() => {this.closePortalModal('viewPortalModalStatus')}}
          show={this.state.viewPortalModalStatus}
          portalData={this.state.selectedPortal}
        />

        <div className={styles.px38}>
          <div className={`content-pane-90 ${styles["mb80"]}`}>
            <div className={styles.headerContainer}>
              <span>
                Portal
              </span>

              <button className={`btn btn-success font-16 ${styles["addBtn"]}`} onClick={(e)=>{this.openPortalModal(e, 'addPortalModalStatus')}}>
                Add Portal
              </button>
            </div>

            {
              allPortals.portal.length === 0 && <Fragment>
                <div className={styles.root}>
                  <Typography className={styles.typography15}>
                    <span className={styles.p20}>
                      No portals available
                    </span>
                  </Typography>
                </div>
              </Fragment>
            }

            <Fragment>
              {Object.entries(groupedData).map((groupedItem) => this.renderOrganizationRow(groupedItem, classes))}
            </Fragment>
          </div>
        </div>
      </Fragment>

      )
  }
}

function mapStateToProps(state) {
  const { portals: { allPortalData, error, loading } } = state;
  return {
    loading,
    allPortals : allPortalData,
    error,
  };
}

const connectedPortal = connect(mapStateToProps)(Portal);
export { connectedPortal as Portal };